// components/LoadingBackdrop.js
import React from 'react';
import { Backdrop, CircularProgress, Typography } from '@mui/material';

const LoadingBackdrop = ({ loading, retryCount }) => {
  return (
    <Backdrop
      open={loading}
      sx={{ 
        color: 'common.white', 
        zIndex: (theme) => theme.zIndex.drawer + 1,
        display: 'flex',
        flexDirection: 'column',
        gap: 2
      }}
    >
      <CircularProgress color="inherit" />
      <Typography variant="h6">
        Generating report...
      </Typography>
      {retryCount > 0 && (
        <Typography variant="subtitle1">

        </Typography>
      )}
    </Backdrop>
  );
};

export default LoadingBackdrop;
